import { DatePipe, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';
import { FeatherModule } from 'angular-feather';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthComponent } from './auth/auth.component';
import { PermissionDirective } from './auth/permission.directive';
import { ContactComponent } from './bankportal/components/Contact/contact-info.component';
import { TransactionEntryComponent } from './bankportal/components/TransactionEntry/transaction-entry.component';
import { TransactionReportComponent } from './bankportal/components/TransactionReport/transaction-report.component';
import { AccessoriesRequestComponent } from './bankportal/components/accessories/accessories-requests.component';
import { MerchantAccessoriesRequest } from './bankportal/components/merchant-accessories-request/merchant-accessories-request.component';
import { MerchantSupportRequest } from './bankportal/components/merchant-support-request/merchant-support-request.component';
import { MerchantsCardFonepayAndNepalpayComponent } from './bankportal/components/merchants-details/merchants-cardfonepayandnepalpay/merchants-cardfonepayandnepalpay.component';
import { MerchantsConfigurationComponent } from './bankportal/components/merchants-details/merchants-configurations/merchants-configuration.component';
import { MerchantsDeploymentInformationComponent } from './bankportal/components/merchants-details/merchants-deployment-information/merchants-deployment-information.component';
import { MerchantsLocationComponent } from './bankportal/components/merchants-details/merchants-location/merchants-location.component';
import { ProgressComponent } from './bankportal/components/progress/progress.component';
import { BankReconfigureComponent } from './bankportal/components/reconfigure/reconfigure-request.component';
import { BankRemovalComponent } from './bankportal/components/removal/removal.component';
import { AccessoriesRequestDetailsComponent } from './bankportal/components/reports/accessories-request-details.component';
import { BankPortalReconfigureHistoryComponent } from './bankportal/components/reports/reconfigure-history.component';
import { SupportAndAccessoriesRequest } from './bankportal/components/support-and-accessories-request/support-and-accessories-request.component';
import { SwitchTransactionEntryComponent } from './bankportal/components/switch-transaction-entry/switch-transaction-entry.component';
import { ConfirmationComponent } from './bankportal/confirmation/confirmation.component';
import { DndDirective } from './bankportal/directives/drag-and-drop-file.directive';
import { MerchantRollRequestComponent } from './bankportal/merchantRollRequest/merchantRollRequest.component';
import { MerchantSupportComponent } from './bankportal/merchantSupport/merchantSupport.component';
import { TokenInterceptorService } from './core/interceptors/bankportal.tokeninterceptor';
import { AuthGuard } from './core/services/auth-guard.service';
import { BankPortalAuthService } from './core/services/bankportal-auth.service';
import { SignalRService } from './core/services/signalR.service';
import { ValidationErrorHandlerService } from './core/services/validation-error-handler.service';
import { TableComponent } from './home/Table/table.component';
import { TableDetailComponent } from './home/TableDetail/table.component';
import { SharedModule } from './shared/shared.module';
import { API_BASE_URL, AppAccountService, BankPortalService, NotificationUserService, TransactionDashboardService } from './web-api-client';
import { PageNotFoundComponent } from './shared/page-not-found/page-not-found.component';
import { TransactionListComponent } from './bankportal/components/reports/transaction-list/transaction-list.component';
// import { UpdatePermissionComponent } from './update-permission/update-permission.component';

const icons = {
    Camera: 'Camera',
    Heart: 'Heart',
    Github: 'Github'
};
@NgModule({

    declarations: [
        AppComponent,
        AuthComponent,
        PageNotFoundComponent,
        // UpdatePermissionComponent,

        ConfirmationComponent,
        AccessoriesRequestComponent,
        TransactionReportComponent,
        ProgressComponent,
        TransactionEntryComponent,
        // AccessoriesComponent,
        TableComponent,
        TableDetailComponent,
        SupportAndAccessoriesRequest,
        BankRemovalComponent,
        AccessoriesRequestDetailsComponent,
        BankPortalReconfigureHistoryComponent,
        // MerchantSupportComponent,
        MerchantRollRequestComponent,
        BankReconfigureComponent,
        ContactComponent,
        MerchantAccessoriesRequest,
        MerchantSupportRequest,
        DndDirective,
        SwitchTransactionEntryComponent,
        
        MerchantsCardFonepayAndNepalpayComponent,
        MerchantsDeploymentInformationComponent
        
        


    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        ToastrModule,
        ToastrModule.forRoot({
            timeOut: 3000,
            progressBar: true,
            tapToDismiss: true,
            preventDuplicates: true,
            countDuplicates: false,
            easeTime: 800,
            positionClass: 'toast-bottom-right'
        }),
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        FeatherModule.pick(icons),
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptorService, multi: true },
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        AuthGuard,
        DatePipe,
        {
            provide: API_BASE_URL,
            useValue: environment.web_client_url
        },
        ValidationErrorHandlerService ,       
        BankPortalService,
        BankPortalAuthService,
        AppAccountService,
                
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
